module.exports = __webpack_public_path__ + "img/28_38.20ff36dd.png";